export default function(active: boolean) {
  return active
    ? "Active"
    : "Not active";
}